import React from 'react';
import { Outlet } from 'react-router-dom';
import Topbar from './Topbar';
import { useAuth } from '../../../features/auth';

/**
 * App shell: sticky topbar + scrollable main.
 */
const Layout: React.FC = () => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="flex h-screen flex-col overflow-hidden bg-[#F1F5F9]">
      <Topbar />
      <main className="flex-1 overflow-auto p-4 md:p-6">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
